import React from "react";
import PropTypes from "prop-types";
//widgets
import { withStyles } from "@material-ui/core/styles";
import Chip from "@material-ui/core/Chip";
//local
import {
  defaultFont,
  roseColor,
  primaryColor,
  infoColor,
  successColor,
  warningColor,
  dangerColor,
  primaryBoxShadow,
  infoBoxShadow,
  successBoxShadow,
  warningBoxShadow,
  dangerBoxShadow,
  roseBoxShadow,
} from "../styles";

function CustomChip({ ...props }) {
  const { classes, color, className, ...rest } = props;

  const classColor = color
    ? classes[color + (props.variant === "outlined" ? "Outline" : "")]
    : "";
  const clickColor = color ? classes[color + "Click"] : "";

  return (
    <Chip
      classes={{
        root: `${classes.chip} ${classColor} ${className}`,
        deleteIcon:
          color && props.variant !== "outlined" ? classes.icon : undefined,
        clickable: clickColor,
      }}
      {...rest}
    />
  );
}

CustomChip.propTypes = {
  classes: PropTypes.object.isRequired,
  color: PropTypes.oneOf([
    "warning",
    "success",
    "danger",
    "info",
    "primary",
    "rose",
  ]),
};

const styles = theme => ({
  chip: {
    margin: theme.spacing(1),
    ...defaultFont,
  },
  icon: {
    color: "rgba(255, 255, 255, 0.26)",
    "&:hover": {
      color: "rgba(255, 255, 255, 0.4)",
    },
  },
  info: {
    color: "#ffffff",
    backgroundColor: infoColor[0],
    "&:focus": {
      backgroundColor: infoColor[1],
    },
  },
  infoOutline: {
    color: "rgba(0, 0, 0, 0.87)",
    borderColor: infoColor[0],
  },
  infoClick: {
    "&:hover": {
      backgroundColor: infoColor[0],
      ...infoBoxShadow,
    },
  },
  success: {
    color: "#ffffff",
    backgroundColor: successColor[0],
    "&:focus": {
      backgroundColor: successColor[1],
    },
  },
  successOutline: {
    color: "rgba(0, 0, 0, 0.87)",
    borderColor: successColor[0],
  },
  successClick: {
    "&:hover": {
      backgroundColor: successColor[0],
      ...successBoxShadow,
    },
  },
  warning: {
    color: "#ffffff",
    backgroundColor: warningColor[0],
    "&:focus": {
      backgroundColor: warningColor[1],
    },
  },
  warningOutline: {
    color: "rgba(0, 0, 0, 0.87)",
    borderColor: warningColor[0],
  },
  warningClick: {
    "&:hover": {
      backgroundColor: warningColor[0],
      ...warningBoxShadow,
    },
  },
  danger: {
    color: "#ffffff",
    backgroundColor: dangerColor[0],
    "&:focus": {
      backgroundColor: dangerColor[1],
    },
  },
  dangerOutline: {
    color: "rgba(0, 0, 0, 0.87)",
    borderColor: dangerColor[0],
  },
  dangerClick: {
    "&:hover": {
      backgroundColor: dangerColor[0],
      ...dangerBoxShadow,
    },
  },
  primary: {
    color: "#ffffff",
    backgroundColor: primaryColor[0],
    "&:focus": {
      backgroundColor: primaryColor[1],
    },
  },
  primaryOutline: {
    color: "rgba(0, 0, 0, 0.87)",
    borderColor: primaryColor[0],
  },
  primaryClick: {
    "&:hover": {
      backgroundColor: primaryColor[0],
      ...primaryBoxShadow,
    },
  },
  rose: {
    color: "#ffffff",
    backgroundColor: roseColor[0],
    "&:focus": {
      backgroundColor: roseColor[1],
    },
  },
  roseOutline: {
    color: "rgba(0, 0, 0, 0.87)",
    borderColor: roseColor[0],
  },
  roseClick: {
    "&:hover": {
      backgroundColor: roseColor[0],
      ...roseBoxShadow,
    },
  },
});

export default withStyles(styles)(CustomChip);
